
var mapStyles = { 
    "1": [], 

    "2": [
        {
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#f5f5f5"
            }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#616161"
            }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
            {
                "color": "#f5f5f5"
            }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#bdbdbd"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#eeeeee"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#757575"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#e5e5e5"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#9e9e9e"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#ffffff"
            }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#757575"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#dadada"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#616161"
            }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#9e9e9e"
            }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#e5e5e5"
            }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#eeeeee"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#c9c9c9"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#9e9e9e"
            }
            ]
        }
    ], 

    "3": [
        {
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#ebe3cd"
            }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#523735"
            }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
            {
                "color": "#f5f1e6"
            }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#c9b2a6"
            }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#dcd2be"
            }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#ae9e90"
            }
            ]
        },
        {
            "featureType": "landscape.natural",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#dfd2ae"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#dfd2ae"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#93817c"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "color": "#a5b076"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#447530"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#f5f1e6"
            }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#fdfcf8"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#f8c967"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#e9bc62"
            }
            ]
        },
        {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#e98d58"
            }
            ]
        },
        {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#db8555"
            }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#806b63"
            }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#dfd2ae"
            }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#8f7d77"
            }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "labels.text.stroke",
            "stylers": [
            {
                "color": "#ebe3cd"
            }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#dfd2ae"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "color": "#b9d3c2"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#92998d"
            }
            ]
        }
    ], 
    
    "4": [
        {
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#242f3e"
            }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#746855"
            }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
            {
                "color": "#242f3e"
            }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#d59563"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#d59563"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#263c3f"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#6b9a76"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#38414e"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#212a37"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#9ca5b3"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#746855"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#1f2835"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#f3d19c"
            }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#2f3948"
            }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#d59563"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
            {
                "color": "#17263c"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
            {
                "color": "#515c6d"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.stroke",
            "stylers": [
            {
                "color": "#17263c"
            }
            ]
        }
    ], 
};

function initializeMap_v2(id, { locations, mapStyle, zoom, markerIcon }) {

    var map = new google.maps.Map(document.getElementById(id), {
        zoom: zoom,
        center: new google.maps.LatLng(locations[0].lat, locations[0].lng),
        styles: mapStyles[mapStyle],
    });


    /*var mapMarker = {
        path: "M31.5 17C31.5 20.9416 30.2475 24.9778 28.3148 29.126C26.3817 33.2751 23.7875 37.4973 21.1319 41.8182L21.1283 41.824C19.3859 44.6592 17.6184 47.535 16.0089 50.4429C14.2381 47.114 12.2752 43.8592 10.363 40.6886L10.3589 40.6818C7.79642 36.4328 5.32919 32.3407 3.5 28.3804C1.6708 24.4201 0.5 20.633 0.5 17C0.5 7.84656 6.92635 0.5 16 0.5C25.0736 0.5 31.5 7.84656 31.5 17ZM16 30.5C18.7301 30.5 21.1128 28.5864 22.7829 26.0229C24.4622 23.4453 25.5 20.1011 25.5 17C25.5 11.7533 21.2467 7.5 16 7.5C10.7533 7.5 6.5 11.7533 6.5 17C6.5 20.1011 7.53785 23.4453 9.2171 26.0229C10.8872 28.5864 13.2699 30.5 16 30.5Z",
        fillColor: "black",
        fillRule:"evenodd",
        clipRule:"evenodd",
        strokeColor: "black",
        anchor: new google.maps.Point(
            32, // width
            52 // height
        ),
    };*/

    var mapMarker = {
        url: 'https://cdn.shopify.com/s/files/1/0959/8985/8641/files/location-pin.png?v=1758009393',   // image file in assets
        scaledSize: new google.maps.Size(50, 68),    // resize as needed
        anchor: new google.maps.Point(20, 40)        // center the pin correctly
    };

    var marker, i;

    for (i = 0; i < locations.length; i++) {
        marker = new google.maps.Marker({
            position: new google.maps.LatLng(locations[i].lat, locations[i].lng),
            map: map,
            icon: mapMarker,
            title: locations[i].location,
            zIndex: 3
        });
    }
}

function map(){

    var mapSelectors = document.querySelectorAll('.section-map-addresses-list-item');

    for( let map of mapSelectors){
        var latlng = map.dataset.latlng
        var mapId = map.dataset.targetId
        var mapStyle = map.dataset.mapStyle
        var location = map.querySelector('.section-map-addresses-list-item__location').innerText;
        var address = map.querySelector('.section-map-addresses-list-item__address').innerText;

        if(latlng){
            var coordinates = latlng.split(",")

            initializeMap_v2(mapId, { 
                locations: [
                    {
                        location: location,
                        address: address,
                        lat: coordinates[0],
                        lng: coordinates[1]
                    }
                ], 
                mapStyle: mapStyle, 
                zoom: 15 
            });
        }
    }

}

// map();

class LocationMap extends HTMLElement{
    constructor(){
        super();

        var mapDetails = this.querySelectorAll('.section-map-addresses-list-item');
        var maps = this.querySelectorAll('.section-map-maps-map');

        if( mapDetails.length > 0 ){
            mapDetails[0].classList.add('active');
        }
        if( maps.length > 0 ){
            maps[0].classList.add('active');
        }

        mapDetails.forEach((mapData, i)=> {
            mapData.addEventListener('click', (event) => {
                
                mapDetails.forEach((mapDetail) => { mapDetail.classList.remove('active') })
                if(maps.length > 0){
                    maps.forEach((map) => { map.classList.remove('active') })
                }

                mapData.classList.contains('active') ? mapData.classList.remove('active') : mapData.classList.add('active')
                if(maps.length > 0){
                    maps[i].classList.contains('active') ? maps[i].classList.remove('active') : maps[i].classList.add('active')
                }
            })


            // console.log("title visible", mapData.matches(':focus-visible'));
            if( mapData.matches(':focus-visible') ){
                console.log("visible");
                // this.onClick();
            }
            // this.querySelector('.collapsible-row__title').matches(':focus-visible').addEventListener('click', (event) => {
            //     this.onClick(event);
            // })

            // mapData.matches(':focus-visible')
        })


        map();
    }


}

customElements.define('location-map', LocationMap);